const TOKEN_SECRET = 'AWD__b98769a2068ff506789be97394830ce3';
//const API_URL = 'http://localhost:8000';
const API_URL = 'https://apitask.awdigital.com.br';
const ID_TOKEN = 'awdigital_token__';
const PERMISSION_TOKEN = 'awdigital_permission__';

export {TOKEN_SECRET, API_URL, ID_TOKEN, PERMISSION_TOKEN};     